import React from 'react'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { BoldText, LabelText } from './StyledComponentsContent'
import { dateToDashString } from '../../../../utils/dateUtility'

export const PaymentCompleteZeroDueContent = (): React.JSX.Element => {
  const { t } = useTranslation()

  return (
    <>
      <Typography variant="body1" align="center">
        {t(
          'PaymentModal.Instructions.EnrollmentEmail',
          'Check your inbox for successful enrollment emails for each of your new programs.'
        )}
      </Typography>
      <LabelText variant="subtitle2" align="center">
        {t('PaymentModal.Label.DateConfirmed', 'Date Confirmed')}
        <BoldText variant="body2">{dateToDashString(new Date())}</BoldText>
      </LabelText>
    </>
  )
}
